import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"
import { patch } from "@rails/request.js"

// Connects to data-controller="review-modal"
export default class extends Controller {
  static values = {
    serviceId: String,
    orderId: String,
    isRecommend: Boolean // true: レビューモーダルを自動で表示
  }

  connect() {
    if (this.isRecommendValue) this.recommend();

    this.focusTextarea();
  }

  // レビュー依頼（１回きり）
  recommend() {
    // モーダルを表示
    setTimeout(function(){
      Modal.getOrCreateInstance(this.element).show();
    }.bind(this), 1000);

    // モーダルを閉じた際、レビュー依頼済みにするためのリクエストを送信
    this.element.addEventListener("hidden.bs.modal", () => {
      if (!this.isRecommendValue) return;

      patch(`/services/${this.serviceIdValue}/orders/${this.orderIdValue}/recommend`, {})
      // リクエスト送信後はフラグをオフにし、同一画面でのモーダル再表示時のリクエストを防ぐ
      this.isRecommendValue = false;
    });
  }

  // 感想コメントのテキストエリアにフォーカスを当てる
  focusTextarea() {
    this.element.addEventListener("shown.bs.modal", () => {
      document.getElementById("skill_order_comment").focus();
    });
  }

  // 「内容を確認する」ボタンクリック時の挙動
  confirm() {
    this.element.classList.add("is_confirm");
    this.element.querySelector(".status").classList.add("is_confirm");

    const commentInput = this.element.querySelector(".commentInput").value.trim();
    const commentElement = this.element.querySelector(".comment");
    const noCommentElement = this.element.querySelector(".noComment");

    if (commentInput === "") {
      commentElement.classList.add("d-none");
      noCommentElement.classList.remove("d-none");
    } else {
      commentElement.innerHTML = commentInput.replace(/\r?\n/g, "<br>");
      commentElement.classList.remove("d-none");
      noCommentElement.classList.add("d-none");
    }
  }

  // 感想コメントの確認画面で「戻る」ボタンクリック時の挙動
  confirmBack() {
    this.element.classList.remove("is_confirm");
    this.element.querySelector(".status").classList.remove("is_confirm");
  }

  // submitボタンをクリックしたら無効化＆ローディングアイコン表示（二重送信の防止）
  submitReview() {
    const submitButton = this.element.querySelector("#submitButton");
    const cancelReviewButton = this.element.querySelector("#cancelReviewButton");

    submitButton.disabled = true;
    cancelReviewButton.disabled = true;

    document.querySelector(".sending").style.display = "block";
    return false;
  }
}
